module.exports = __webpack_public_path__ + "img/activity20.8ec61e50.jpg";